import type {
	ClientPortfolioPensionProductsCreateRequestDTO,
	ClientPortfolioPensionProductsEditRequestDTO,
} from "web_myplann/Infrastructure/Api/Api";
import type {
	PensionCreateFormOutput,
	PensionEditFormOutput,
} from "web_myplann/Portfolio/Forms/PensionForm/pensionFormSchema";
import { mapManualValueToRequest } from "web_myplann/Portfolio/PortfolioShared/ManualValue/mapManualValueToRequest";

export const mapPensionCreateFormToRequest = (
	data: PensionCreateFormOutput,
): ClientPortfolioPensionProductsCreateRequestDTO => {
	const { value, invested, valueDate, ...contract } = data;
	return {
		...contract,
		manualValue: mapManualValueToRequest({ value, invested, valueDate }),
	};
};

export const mapPensionEditFormToRequest = (
	data: Partial<PensionEditFormOutput>,
	{ payment, paymentFrequency }: PensionEditFormOutput,
): Partial<ClientPortfolioPensionProductsEditRequestDTO> => {
	const isPaymentChanged = "payment" in data || "paymentFrequency" in data;

	return {
		...data,
		...(isPaymentChanged && { payment, paymentFrequency }),
	};
};
